import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import Cases from '../components/Cases/Cases';

const Home = () => {
  return (
    <div className="home" activePage="/">
      <Header color="white" />
      <Hero />
      <Services />
      <Cases />
    </div>
  );
};

export default Home;
